export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-200px.jpg.3c9abb20.webp";